// Only ever navigate to a same-origin absolute path. Reject protocol-relative (`//`)
// or absolute URLs so a crafted `returnTo` can't bounce the user off-origin.
// Backslashes are rejected outright: browsers normalize `\` to `/` in URLs, so
// `/\evil.com` would resolve as the protocol-relative `//evil.com`.
export function safeReturnPath(raw: string | null | undefined, fallback = "/"): string {
  if (!raw) return fallback;
  if (!raw.startsWith("/") || raw.startsWith("//") || raw.includes("\\")) return fallback;
  return raw;
}

export function safeReturnTo(query: URLSearchParams, fallback = "/"): string {
  return safeReturnPath(query.get("returnTo"), fallback);
}
